import { faArrowLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import callApi from "services/api";
import { selectLoading, setLoading } from "state/slices/loaderSlice";
import { setLoginView } from "state/slices/loginViewSlice";
import * as Yup from "yup";
import { useState } from "react";
import { setResetData } from "state/slices/resetPasswordSlice";
import { useRef } from "react";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const tokenRef = useRef("");
  const [step, setStep] = useState(1); // 1 = username, 2 = OTP
  const [username, setUsername] = useState("");
  const [token, setToken] = useState("");
  const formik = useFormik({
    initialValues: {
      registrationNumber: "",
      otp: "",
    },
    validationSchema: Yup.object({
      registrationNumber:
        step === 1
          ? Yup.string().required("Please enter your username.")
          : Yup.string(),
      otp:
        step === 2
          ? Yup.string()
            .required("Please enter OTP")
            .matches(/^\d{6}$/, "OTP must be 6 digits")
          : Yup.string(),
    }),
    onSubmit: async (values) => {
      if (step === 1) {
        await sendOtp(values.registrationNumber);
      } else {
        await verifyOtp(values.otp);
      }
    },
  });

  const sendOtp = async (usernameValue) => {
    dispatch(setLoading(true));

    const response = await callApi(
      `/forgot-password`,
      "POST",
      { username: usernameValue },
      true,
      false,
      dispatch,
      navigate
    );

    dispatch(setLoading(false));

    if (response?.success) {
      const receivedToken = response?.body?.body?.Token;
      setUsername(usernameValue);
      setToken(receivedToken);
      tokenRef.current = receivedToken;
      setStep(2);
    }
  };

  const verifyOtp = async (otpValue) => {
    dispatch(setLoading(true));

    const response = await callApi(
      `/verify-otp`,
      "POST",
      {
        username,
        otp: otpValue,
        token: tokenRef.current,
      },
      true,
      false,
      dispatch,
      navigate
    );

    dispatch(setLoading(false));

    if (response?.success) {
      dispatch(setResetData({ username, token: tokenRef.current }));
      dispatch(setLoginView("reset-password"));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      formik.handleSubmit();
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-8">
        <div className="card">
          <div className="card-body">

            <h3 className="text-center">
              {step === 1 ? "Forgot Password" : "Verify OTP"}
            </h3>

            <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>

              {/* ✅ STEP 1: USERNAME */}
              {step === 1 && (
                <div className="mb-3">
                  <label className="form-label">
                    Username <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    name="registrationNumber"
                    className={`form-control ${formik.touched.registrationNumber &&
                      formik.errors.registrationNumber
                      ? "is-invalid"
                      : ""
                      }`}
                    {...formik.getFieldProps("registrationNumber")}
                    placeholder="Enter your username"
                  />

                  {formik.touched.registrationNumber &&
                    formik.errors.registrationNumber && (
                      <div className="invalid-feedback">
                        {formik.errors.registrationNumber}
                      </div>
                    )}
                </div>
              )}

              {/* ✅ STEP 2: OTP */}
              {step === 2 && (
                <div className="mb-3">
                  <label className="form-label">
                    Enter OTP <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    name="otp"
                    className={`form-control ${formik.touched.otp && formik.errors.otp
                      ? "is-invalid"
                      : ""
                      }`}
                    {...formik.getFieldProps("otp")}
                    placeholder="Enter 6-digit OTP"
                    maxLength={6}
                  />

                  {formik.touched.otp && formik.errors.otp && (
                    <div className="invalid-feedback">
                      {formik.errors.otp}
                    </div>
                  )}
                </div>
              )}

              {/* ✅ BUTTON */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-info w-100"
                  disabled={loading}
                >
                  {loading && (
                    <FontAwesomeIcon icon={faSpinner} className="me-2" />
                  )}
                  {step === 1 ? "Send OTP" : "Verify OTP"}
                </button>
              </div>
            </form>

            {/* ✅ BACK */}
            <div className="d-flex justify-content-center mt-3">
              <button
                className="btn btn-link"
                onClick={() => dispatch(setLoginView("login"))}
              >
                <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                Login
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;